// src/components/Header.js
import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { loadCSS } from '../utils/cssLoader';

export default function Header({ active }) {
    
    // Load Header CSS
    useEffect(() => {
        loadCSS('header.css');
    }, []);
    const location = useLocation();
    const [menuOpen, setMenuOpen] = useState(false);
    const menuRef = useRef(null);
    const buttonRef = useRef(null);

    const toggleMenu = () => setMenuOpen(!menuOpen);

    // Cerrar menú cuando se hace clic fuera
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target) && 
                buttonRef.current && !buttonRef.current.contains(event.target)) {
                setMenuOpen(false);
            }
        };

        const handleEscape = (event) => {
            if (event.key === 'Escape') {
                setMenuOpen(false);
            }
        };

        if (menuOpen) {
            document.addEventListener('mousedown', handleClickOutside);
            document.addEventListener('keydown', handleEscape);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleEscape);
        };
    }, [menuOpen]);

    // Cerrar menú cuando cambia la ruta
    useEffect(() => {
        setMenuOpen(false);
    }, [location.pathname]);

    // useEffect(() => {
    //     let prevScrollpos = window.pageYOffset;

    //     const handleScroll = () => {
    //         const currentScrollpos = window.pageYOffset;
    //         const topWrapper = document.getElementById("top-wrapper");
    //         if (!topWrapper) return;

    //         if (prevScrollpos > currentScrollpos) {
    //             topWrapper.style.top = "0";
    //         } else {
    //             topWrapper.style.top = "-110px";
    //         }
    //         prevScrollpos = currentScrollpos;
    //     };

    //     window.addEventListener("scroll", handleScroll);

    //     return () => {
    //         window.removeEventListener("scroll", handleScroll);
    //     };
    // }, []);

    // Determinar la ruta activa
    const getActive = (path) => {
        if (path === '/') return location.pathname === '/';
        return location.pathname.startsWith(path);
    };

    return (
        <div className="top-wrapper" id="top-wrapper">
            <div className="top-bar">
                <a className="contact-item contact-phone" href="tel:+522283667786">
                    <span className="icon" aria-label="Teléfono">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="10" cy="10" r="10" fill="#388e3c"/>
                            <path d="M14.13 12.29l-1.2-.27a1.13 1.13 0 0 0-1.09.32l-.52.53a7.13 7.13 0 0 1-3.36-3.36l.53-.52a1.13 1.13 0 0 0 .32-1.09l-.27-1.2A1.13 1.13 0 0 0 7.45 6H6.38A1.13 1.13 0 0 0 5.25 7.13c0 4.32 3.5 7.82 7.82 7.82A1.13 1.13 0 0 0 14.13 13.62v-1.07a1.13 1.13 0 0 0-.87-1.26z" fill="#fff"/>
                        </svg>
                    </span>
                    <span className="contact-text">+52 228 366 7786</span>
                </a>
                <a className="contact-item contact-mail" href="mailto:ventas_orsan@hotmail.com">
                    <span className="icon" aria-label="Correo">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="10" cy="10" r="10" fill="#1976d2"/>
                            <path d="M5 7.5v5A1.5 1.5 0 006.5 14h7a1.5 1.5 0 001.5-1.5v-5A1.5 1.5 0 0013.5 6h-7A1.5 1.5 0 005 7.5zm1.7.5l3.3 2.5 3.3-2.5v.7l-3.3 2.5-3.3-2.5v-.7z" fill="#fff"/>
                        </svg>
                    </span>
                    <span className="contact-text">ventas_orsan@hotmail.com</span>
                </a>
            </div>

            <header className="header">
                <div className="header__left">
                    <div className="header__logos">
                        <Link to="/">
                            <img src="/logo-orsan-c.webp" alt="Orsan Logo" className="logo logo--a" />
                        </Link>
                    </div>
                    <button 
                        ref={buttonRef}
                        className="hamburger" 
                        onClick={toggleMenu} 
                        aria-label="Menu"
                        aria-expanded={menuOpen}
                    >
                        <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 1h24M0 9h24M0 17h24" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                        </svg>
                    </button>
                </div>

                <nav 
                    ref={menuRef}
                    className={`header__nav ${menuOpen ? 'open' : ''}`}
                    role="navigation"
                    aria-hidden={!menuOpen}
                >
                    <Link to="/" className={`nav__link${getActive('/') ? ' active' : ''}`} onClick={() => setMenuOpen(false)}>Inicio</Link>
                    <Link to="/properties" className={`nav__link${getActive('/properties') ? ' active' : ''}`} onClick={() => setMenuOpen(false)}>Propiedades</Link>
                    <Link to="/nosotros" className={`nav__link${getActive('/nosotros') ? ' active' : ''}`} onClick={() => setMenuOpen(false)}>Nosotros</Link>
                    <Link to="/contacto" className={`nav__link${getActive('/contacto') ? ' active' : ''}`} onClick={() => setMenuOpen(false)}>Contacto</Link>
                </nav>
            </header>
        </div>
    );
}
